class MultiSkeleton {
    constructor(skeletons) {
        this._skeletons = Object.freeze(Object.assign({}, skeletons));
    }

    get skeletons() {
        return this._skeletons;
    }
}

export default MultiSkeleton;
